import { createClient } from '@supabase/supabase-js';
import { getSupabaseConfig } from '@/lib/config/environment';

// Use environment-specific Supabase configuration
const config = getSupabaseConfig();

export const supabase = createClient(config.url, config.anonKey);
